/* LF collection filter bar (2026 theme): snippets/lf-filter-bar.liquid.
   The form is a plain GET, so every change reloads the collection.
   The tray's open state survives the reload via sessionStorage, and
   the page scrolls back to the bar (a #fragment jump shifted the page
   sideways on mobile).

   click Filter  --> toggle tray, remember state
   tick a filter --> debounce --> submit --> reload, tray re-opens
   pick a sort   --> submit
   chip / Clear  --> follow link --> reload, same as above
*/
(() => {
  const ROOT_SELECTOR = '[data-lf-fb]';
  const LABEL_SELECTOR = '[data-lf-fb-label]';
  const STORE_KEY = 'lf-filter-bar-open';
  const RETURN_KEY = 'lf-filter-bar-return';
  const SHOW_LABEL = 'Filter';
  const HIDE_LABEL = 'Hide filter';
  const SUBMIT_DELAY_MS = 600;
  const OPEN = '1';
  const STICKY_HEADER_PX = { desktop: 130, mobile: 77 };
  const DESKTOP_QUERY = '(min-width: 768px)';

  const root = document.querySelector(ROOT_SELECTOR);
  if (!root) {
    return;
  }

  const form = root.querySelector('form');
  const toggle = root.querySelector('.lf-fb__toggle');
  const tray = root.querySelector('.lf-fb__tray');
  const label = root.querySelector(LABEL_SELECTOR);
  let submitTimer = null;

  // Storage can throw (private mode, blocked site data); state is optional
  function store(key, on) {
    try {
      sessionStorage.setItem(key, on ? OPEN : '');
    } catch (error) {
      // Tray just starts closed, page at the top
    }
  }

  function stored(key) {
    try {
      return sessionStorage.getItem(key) === OPEN;
    } catch (error) {
      return false;
    }
  }

  // Back to the bar after a filter reload, clear of the sticky header
  function returnToBar() {
    if (!stored(RETURN_KEY)) {
      return;
    }

    store(RETURN_KEY, false);
    const header = window.matchMedia(DESKTOP_QUERY).matches
      ? STICKY_HEADER_PX.desktop
      : STICKY_HEADER_PX.mobile;
    window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - header });
  }

  function setTray(open) {
    tray.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    label.textContent = open ? HIDE_LABEL : SHOW_LABEL;
    store(STORE_KEY, open);
  }

  toggle.addEventListener('click', () => setTray(tray.hidden));

  form.addEventListener('submit', () => store(RETURN_KEY, true));
  root.querySelectorAll('.lf-fb__active a').forEach((link) => {
    link.addEventListener('click', () => store(RETURN_KEY, true));
  });

  // Ticks apply without an Apply button, batching quick clicks
  form.addEventListener('change', (event) => {
    clearTimeout(submitTimer);
    if (event.target.name === 'sort_by') {
      form.requestSubmit();
      return;
    }

    submitTimer = setTimeout(() => form.requestSubmit(), SUBMIT_DELAY_MS);
  });

  // Empty values can't narrow the results; ignore clicks on them
  root.querySelectorAll('.lf-fb__option[data-empty] input').forEach((input) => {
    input.disabled = true;
  });

  setTray(stored(STORE_KEY));
  returnToBar();
})();
